'use client';

import { useQuery } from '@tanstack/react-query';
import { renderTokenPricesService } from '../api/render-token-prices.service';

/**
 * Effort token prices come from the server (`GET /v1/renders/token-prices`),
 * never a local constant — the backend tunes them under demand and a stale
 * hardcoded value would mislead the user about cost. Returns a
 * `Record<RenderEffort, number>` mapped by effort id.
 *
 * `refetchOnMount: 'always'` refetches whenever the settings panel mounts so a
 * price change on the server is reflected the next time the user opens Effort,
 * while the 5-minute staleTime keeps repeated reads within a session cheap.
 */
export function useRenderTokenPrices() {
  return useQuery({
    queryKey: ['render', 'token-prices'],
    queryFn: () => renderTokenPricesService.getTokenPrices(),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
  });
}
